module.exports = __webpack_public_path__ + "static/media/kh.ad15a684.png";